export default BlumarConfig;



// WEBPACK FOOTER //
// ./src/blumar-config.js